<template>
    <div class="modal modal-light" id="modal-options" tabindex="-1" role="dialog" aria-labelledby="modal-optionsLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="mi close" data-dismiss="modal" aria-label="Close"></button>
                    <h4 class="modal-title" id="modal-optionsLabel">Options and Export</h4>
                </div>
                <div class="modal-body">

                    <div class="row row-buttons">
                        <a @click="downloadDraft" class="col-sm-4">
                            <i class="fa fa-file-pdf-o"></i>
                            <span class="title">Export Client PDF</span>
                        </a>
                        <a @click="downloadCSV" class="col-sm-4">
                            <i class="fa fa-file-excel-o"></i>
                            <span class="title">Export Estimation Spreadsheet</span>
                        </a>
                        <a @click="toggleCollapse" class="col-sm-4">
                            <i class="pe-7s-expand1"></i>
                            <span class="title">Expand All</span>
                        </a>
                    </div><!-- /.row -->
                    <br/>
                    <div class="row row-buttons">
                        <a @click="downloadDraftWithTags" class="col-sm-4">
                            <i class="fa fa-file-pdf-o"></i>
                            <span class="title">Export Client PDF (* with tags)</span>
                        </a>
                        <a @click="downloadYodizUserstoryCSV" class="col-sm-4">
                            <i class="fa fa-file-excel-o"></i>
                            <span class="title">Export Yodiz Userstory CSV</span>
                        </a>
                    </div><!-- /.row -->

                    <h5>Show</h5>
                    <div class="row">
                        <div class="col-6 col-md-4">
                            <div class="checkbox checkbox-primary">
                                <input :checked="view_options.show_description" @change="toggleDescription" type="checkbox" class="styled" id="filter-description">
                                <label for="filter-description"> Description</label>
                            </div>
                        </div>
                        <div class="col-6 col-md-4">
                            <div class="checkbox checkbox-primary">
                                <input :checked="view_options.show_times" @change="toggleTimes" type="checkbox" class="styled" id="filter-estimation">
                                <label for="filter-estimation"> Estimation</label>
                            </div>
                        </div>
                        <div class="col-6 col-md-4">
                            <div class="checkbox checkbox-primary">
                                <input :checked="view_options.show_technical_notes" @change="toggleTechnicalNotes" type="checkbox" class="styled" id="filter-tech-notes" value="tech-notes">
                                <label for="filter-tech-notes"> Technical Notes</label>
                            </div>
                        </div>
                        <div class="col-6 col-md-4">
                            <div class="checkbox checkbox-primary">
                                <input :checked="view_options.show_testing_notes" @change="toggleTestingNotes" type="checkbox" class="styled" id="filter-testing-notes" value="testing-notes">
                                <label for="filter-testing-notes"> Testing Notes</label>
                            </div>
                        </div>
                    </div><!-- /.row -->

                </div>
            </div>
        </div>
    </div><!-- /.modal -->
</template>

<script>
    import { mapMutations, mapState } from 'vuex'
    import { SET_PROPERTY } from 'vx/mutations'
    import auth from 'utils/auth'

    export default {

        mounted () {

            // Make Send Email Modals White
            $(".modal-light").on('shown.bs.modal', function() {
                $('.modal-backdrop').css('background', '#fff');
            });
            $(".modal-light").on('hidden.bs.modal', function() {
                $('.modal-backdrop').css('background', '#000');
            });
        },

        computed: {
            ...mapState('settings/userstories', ['view_options']),
            ...mapState('project', ['project'])
        },

        methods: {
            ...mapMutations('settings/userstories', [SET_PROPERTY]),

            toggleCollapse () {
                this[SET_PROPERTY]({ property: 'view_options.collapsed', value: (!this.view_options.collapsed) })
            },

            downloadDraft () {
                var link = process.env.VUE_APP_API_URL+'/user-story-document/'+this.project.user_story_document_id +'/draft/download?token='+auth.getToken()
                window.open(link)
            },

            downloadDraftWithTags () {
                var link = process.env.VUE_APP_API_URL+'/user-story-document/'+this.project.user_story_document_id +'/draft/download?tags=1&token='+auth.getToken()
                window.open(link)
            },

            downloadCSV () {
                var link = process.env.VUE_APP_API_URL+'/user-story-document/'+this.project.user_story_document_id +'/draft/csv?token='+auth.getToken()
                window.open(link)
            },

            downloadYodizUserstoryCSV () {
                var link = process.env.VUE_APP_API_URL+'/user-story-document/'+this.project.user_story_document_id +'/export/yodiz-csv?token='+auth.getToken()
                window.open(link)
            },

            toggleTimes () {
                this[SET_PROPERTY]({ property: 'view_options.show_times', value: (!this.view_options.show_times) })
            },

            toggleDescription () {
                this[SET_PROPERTY]({ property: 'view_options.show_description', value: (!this.view_options.show_description) })
            },

            toggleTechnicalNotes () {
                this[SET_PROPERTY]({ property: 'view_options.show_technical_notes', value: (!this.view_options.show_technical_notes) })
            },

            toggleTestingNotes () {
                this[SET_PROPERTY]({ property: 'view_options.show_testing_notes', value: (!this.view_options.show_testing_notes) })
            }
        }
    }
</script>

<style scoped>
    .modal-backdrop {
        background: #fff;
    }
</style>
